function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}

function twitterSharing() {
  return !(function (d, s, id) {
    let js = undefined;
    const twitterjs = d.getElementsByTagName(s)[0];
    const p = /^http:/.test(d.location) ? 'http' : 'https';

    if (!d.getElementById(id)) {
      js = d.createElement(s);
      js.id = id;
      js.src = p + '://platform.twitter.com/widgets.js';
      twitterjs.parentNode.insertBefore(js, twitterjs);
    } else {
      __guardMethod__(typeof twttr !== 'undefined' && twttr !== null ? twttr.widgets : undefined, 'load', o => o.load());
    }
  })(document, 'script', 'twitter-wjs');
}

function googlePlusSharing() {
  return !(function (d, s, id) {
    let js = undefined;
    const googlejs = d.getElementsByTagName(s)[0];

    if (!d.getElementById(id)) {
      js = d.createElement(s);
      js.type = 'text/javascript';
      js.async = true;
      js.src = 'https://apis.google.com/js/plusone.js';
      googlejs.parentNode.insertBefore(js, googlejs);
      return;
    }
  })(document, 'script', 'google-wjs');
}

export { twitterSharing, googlePlusSharing };
